import t from '@instructure/quiz-i18n/format-message';
export var noAnswerMissing = {
  title: t('No Response'),
  body: t('No response is considered as Incorrect answer in this question type.'),
  screenReaderLabel: t('No response tooltip')
};